
import {useAdminContext} from "../../contexts/AdminContext"
import { FaUser } from "react-icons/fa";


interface UserListByBoatProps {
    boatId: string
}

const UserListByBoat: React.FC<UserListByBoatProps> = ({boatId}) => {

    const {tabIdUsers, tabIdBoat2User} = useAdminContext();

    return(
        <div className={`transition-all duration-300 ease-in-out`}>
            {!tabIdBoat2User ? null: (<ul>
                {
                tabIdBoat2User[boatId].length ?
                    tabIdBoat2User[boatId]?.map((userId) => {
                        return(
                            <li key={userId} className="d-flex align-items-center justify-content-between g-2"> 
                                <FaUser/> {tabIdUsers[userId]}
                            </li>
                        )
                    })
                    : "Aucun utilisateur"
                }
            </ul>) }
         </div>
    );
}

export default UserListByBoat;